//redirectServices
export function redirectToDashboard() {
  window.location.href = "/dashboard";
}

export function redirectToLogin() {
  window.location.href = "/login";
}
